<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Checkbox, Container, Tooltip, SelectCard } from '@Shelly/shelly-design-system';
	import { capFirstChar, _deepClone } from '../../../../helpers/utilities';
	import type { ISceneObj } from '../../../../types/SceneType';
	import { beforeUpdate } from 'svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let scene_object: ISceneObj;

	let run_on_save = scene_object._run_on_ingest || false;
	let scene_enable_val = scene_object?._enabled || false;
	let allowed_for_3rd_party = scene_object?._meta?.integrations || false;
	let disable_allowed_3rd_party = scene_object?.do?.find((_do) => {
		return _do.notify === 'alexa_notif' || (_do.blk && _do.blk[0].notify === 'alexa_notif');
	});

	const toggle_ebnable = () => {
		scene_enable_val = !scene_enable_val;

		if (scene_enable_val !== scene_object?._enabled) {
			// let copy_scene: ISceneObj = _deepClone($scene_object) as ISceneObj;
			// copy_scene._enabled = scene_enable_val;
			// scene_object.change(copy_scene);
			scene_object._enabled = scene_enable_val;
		}
	};
	const toggle_run_on_save = () => {
		run_on_save = !run_on_save;

		if (run_on_save !== scene_object?._run_on_ingest) {
			// let copy_scene: ISceneObj = _deepClone($scene_object) as ISceneObj;
			// copy_scene._run_on_ingest = run_on_save;
			// scene_object.change(copy_scene);
			scene_object._run_on_ingest = run_on_save;
		}
	};
	const toogle_allowed_for_3rd_party = () => {
		allowed_for_3rd_party = !allowed_for_3rd_party;

		if (allowed_for_3rd_party !== scene_object?._meta?.integrations) {
			// let copy_scene: ISceneObj = _deepClone($scene_object) as ISceneObj;
			// copy_scene._meta.integrations = allowed_for_3rd_party;
			// scene_object.change(copy_scene);
			scene_object._meta.integrations = allowed_for_3rd_party;
		}
	};

	beforeUpdate(() => {
		disable_allowed_3rd_party = scene_object?.do?.find((_do) => {
			return _do.notify === 'alexa_notif' || (_do.blk && _do.blk[0].notify === 'alexa_notif');
		});
	});
</script>

<Container padding="scrollPaddings">
	<Text styleType="h2" class="mb-s">
		{capFirstChar($format('wizard_step_more_options', { default: 'More options' }))}
	</Text>
	<SelectCard
		cardBgColor={$showNewLayout ? 'color-1' : undefined}
		class="width-full mb-s"
		type="horizontal"
		variant="toggle"
		descriptiveText={$format('enable_scene_description', {
			default: 'If you disable the scene it will not execute until you enable it manually.',
		})}
		selected={scene_enable_val}
		on:click={() => toggle_ebnable()}
		title={capFirstChar($format('enable_scene', { default: 'Enable scene' }))}
	/>
	<!--Hide it until full support is done in integrations-->
	<!--TODO: add check if the scene contains notify Alexa to block it-->
	<!-- <Tooltip
		placement="top"
		title={capFirstChar(
			$format('allow_for_voice_assitants_alert', {
				default: `This setting disabled if the scene contains "Notify Alexa" action`
			})
		)}
	>
		<Checkbox
			checked={allowed_for_3rd_party}
			disabled={disable_allowed_3rd_party}
			on:click={() => toogle_allowed_for_3rd_party()}
			>{capFirstChar(
				$format('allow_for_voice_assitants_title', {
					default: 'Allow for Voice Assistants'
				})
			)}</Checkbox
		>
	</Tooltip> -->

	<SelectCard
		cardBgColor={$showNewLayout ? 'color-1' : undefined}
		class="width-full"
		type="horizontal"
		variant="toggle"
		descriptiveText={$format('run_scene_on_save_description_long', {
			default:
				"This option is good for testing the execution of the scene's actions. Keep in mind that if left enabled, it will trigger the scene whenever you edit it or when certain system changes occur, such as an account timezone change or a Shelly server reset.",
		})}
		selected={run_on_save}
		on:click={() => toggle_run_on_save()}
		title={capFirstChar(
			$format('run_scene_on_save_title', {
				default: 'Execute the scene on save or edit',
			}),
		)}
	/>
</Container>
